module.exports = __webpack_public_path__ + "img/precheckBg.63266f9.jpg";